import { diagnosticStatus, sanitizeCrashReport } from './crashPrivacy';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || 'http://localhost:8020';
const CRASH_REPORT_ENDPOINT = `${API_BASE_URL.replace(/\/$/, '')}/api/v2/crash-reports`;
const unavailable = () => ({ success: false, error: 'Crash reporting unavailable' });
let reporting = false;

export async function reportCrash(crashData) {
  // The endpoint is public. Never read or attach account/backup/session credentials.
  // At most one in-flight report, including a report triggered by reporting failure.
  if (reporting) return unavailable();
  reporting = true;
  let timer;
  try {
    const controller = new AbortController();
    timer = setTimeout(() => controller.abort(), 10000);
    const body = JSON.stringify(sanitizeCrashReport(crashData));
    const transport = window.__nativeFetch || fetch;
    const raw = await transport(CRASH_REPORT_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body,
      credentials: 'omit', referrerPolicy: 'no-referrer', redirect: 'error',
      cache: 'no-store', signal: controller.signal,
    });
    if (!raw.ok) return unavailable();
    const result = JSON.parse(await raw.text());
    // The sole server value retained/displayed is a well-formed correlation ID.
    if (result?.success !== true || typeof result.crash_id !== 'string'
      || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(result.crash_id)) return unavailable();
    return { success: true, crash_id: result.crash_id };
  } catch {
    // No recursive reporting, raw errors, provider responses or console output.
    return unavailable();
  } finally {
    clearTimeout(timer);
    reporting = false;
  }
}

export async function reportNetworkError(errorData = {}) {
  try {
    const status = diagnosticStatus(errorData.status);
    return await reportCrash({
      endpoint: errorData.endpoint, http_status: status, error_type: 'NetworkError',
      route_or_screen: window.location.pathname,
      severity: status >= 500 ? 'CRITICAL' : status >= 400 ? 'WARNING' : 'ERROR',
      metadata: { method: errorData.method, source: 'network' },
    });
  } catch { return unavailable(); }
}

